import SecureLS from "secure-ls";

const rc4LocalStorage = new SecureLS({ encodingType: "rc4" });
const aesLocalStorage = new SecureLS({ encodingType: "aes" });

export const setValue = (k, v, secure = true) => {
  if (typeof v === "object" && v !== null) {
    v = JSON.stringify(v);
  }
  if (secure) {
    aesLocalStorage.set(k, v);
  } else {
    rc4LocalStorage.set(k, v);
  }
  return v;
};

export const getValue = (k, secure = true) => {
  if (secure) {
    return aesLocalStorage.get(k);
  }

  return rc4LocalStorage.get(k);
};

export const getParsedValue = (k, secure = true) => {
  let result = {};
  const val = getValue(k, secure);
  if (val !== undefined && val !== "") {
    result = JSON.parse(val);
  }
  return result;
};

export const deleteKey = (k, secure = true) => {
  if (secure) {
    aesLocalStorage.remove(k);
  } else {
    rc4LocalStorage.remove(k);
  }
};

export const clearStorage = () => {
  aesLocalStorage.removeAll();
  // don't delete unsecured values
  // rc4LocalStorage.removeAll()
};

export const isJSON = (str) => {
  if (!str) {
    return false;
  }

  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}